/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { B2BCalendarDayDto } from './calendarDayDto';
import { B2BCalendarServiceTypeDto } from './calendarServiceTypeDto';


export interface B2BCalendarDto { 
    maxOrdersPerDay?: number;
    maxOrdersPerServiceType?: number;
    maxOrdersPerShop?: number;
    days?: Array<B2BCalendarDayDto> | null;
    availableServiceTypes?: Array<B2BCalendarServiceTypeDto> | null;
}

